let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      // Isolate subscriber errors: one subscriber throwing (e.g. reading
      // event.cartData when a publisher like cart-discount/upsell didn't send
      // it) must NOT break the publisher's own flow or stop other subscribers
      // (such as the cart-drawer re-render) from running.
      try {
        callback(data);
      } catch (error) {
        console.error(`[pubsub] subscriber for "${eventName}" threw:`, error);
      }
    });
  }
}
